import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import FormButtons from "../../Components/GeneralComponents/FormButtons";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { contact_us_api } from "../../DAL/EmailSupport";
import { useContent } from "../../hooks/useContent";
import { useAuth } from "../../hooks/useAuth";

const EmailSupport = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { userInfo } = useAuth();
  const [inputs, setInputs] = useState({
    name: `${userInfo.first_name} ${userInfo.last_name}`,
    email: userInfo.email,
    phone: userInfo.phone_mobile,
    title: "",
    organization: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setPageHeading } = useContent();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: null });
  };

  const validate = () => {
    const newErrors = {};
    if (!inputs.name.trim()) newErrors.name = "Your Name is required";

    if (!inputs.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputs.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!inputs.message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsLoading(true);
    const result = await contact_us_api(inputs);
    if (result.code === 200) {
      enqueueSnackbar(`${result.message}`, { variant: "success" });
      navigate(`/home`);
    } else {
      enqueueSnackbar(`${result.message}`, { variant: "error" });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setPageHeading("Email Support");
  }, []);

  const handleCancel = () => navigate("/home");

  return (
    <div className="login-page container">
      <div className="d-flex justify-content-center">
        <div className="container mx-auto">
          <div className="form-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-end">
                    {/* <FormButtons {...{ isLoading, handleCancel }} /> */}
                  </div>
                </div>

                <div className="col-md-6 form-group">
                  <label htmlFor="name">Your Name *</label>
                  <div className="input-wrapper">
                    <Icon icon="mdi:account-outline" className="input-icon" />
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={inputs.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      className={errors.name ? "has-error" : ""}
                    />
                  </div>
                  {errors.name && (
                    <span className="error-message">
                      <Icon icon="mdi:alert-circle" className="error-icon" />
                      {errors.name}
                    </span>
                  )}
                </div>

                <div className="col-md-6 form-group">
                  <label htmlFor="email">Your Email *</label>
                  <div className="input-wrapper">
                    <Icon icon="mdi:email-outline" className="input-icon" />
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={inputs.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={errors.email ? "has-error" : ""}
                    />
                  </div>
                  {errors.email && (
                    <span className="error-message">
                      <Icon icon="mdi:alert-circle" className="error-icon" />
                      {errors.email}
                    </span>
                  )}
                </div>

                <div className="col-md-6 form-group mt-2">
                  <label htmlFor="phone">Phone</label>
                  <div className="input-wrapper">
                    <Icon icon="mdi:phone-outline" className="input-icon" />
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={inputs.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                </div>

                {/* Title (col-md-6) */}
                <div className="col-md-6 form-group mt-2">
                  <label htmlFor="organization">Organization</label>
                  <div className="input-wrapper">
                    <Icon icon="mdi:domain" className="input-icon" />
                    <input
                      type="text"
                      id="organization"
                      name="organization"
                      value={inputs.organization}
                      onChange={handleChange}
                      placeholder="Your Organization Name"
                    />
                  </div>
                </div>
                <div className="col-md-12 form-group mt-2">
                  <label htmlFor="title">Subject</label>
                  <div className="input-wrapper">
                    <Icon icon="mdi:briefcase-outline" className="input-icon" />
                    <input
                      type="text"
                      id="title"
                      name="title"
                      value={inputs.title}
                      onChange={handleChange}
                      placeholder="Subject"
                    />
                  </div>
                </div>
                <div className="col-md-12 form-group mt-2">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={inputs.message}
                    onChange={handleChange}
                    placeholder="Write your message here..."
                    className={`form-control ${
                      errors.message ? "has-error" : ""
                    }`}
                  ></textarea>
                  {errors.message && (
                    <span className="error-message">
                      <Icon icon="mdi:alert-circle" className="error-icon" />
                      {errors.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="d-flex justify-content-end gap-3 mt-4">
                <FormButtons
                  {...{ isLoading, handleCancel, isRelative: true }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSupport;
